import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../../store/OrderPlannerContact';

class OrderPlanner extends Component {

    componentWillMount() {
        // This method runs when the component is first added to the page
        if (!localStorage.getItem('customer')) {
            window.open('/customer-search', '_self');
        }
        else if (localStorage.getItem('orderPlannerReview')) {
            window.open('/order-planner-review', '_self');
        }
        else if (localStorage.getItem('deliveryModeCode')
            && localStorage.getItem('deliveryModeDescription')
            && localStorage.getItem('badPO') !== "true"
            && localStorage.getItem('badPO') !== true) {

            // Products
            if (localStorage.getItem('requirePO') === 'true' && !localStorage.getItem('orderPO')) {
                window.open('/order-planner-delivery', '_self');
            }
            else {
                window.open('/order-planner-products', '_self');
            }
        }
        else if (localStorage.getItem('orderPlannerContact')) {
            // Delivery information
            window.open('/order-planner-delivery', '_self');
        }
        else if (localStorage.getItem('customer')) {
            // Contact
            window.open('/order-planner-contact', '_self');
        }
    }

    componentWillReceiveProps(nextProps) {
        // This method runs when incoming props (e.g., route params) change
    }

    render() {

        return (
            <div>
                
            </div>
        );
    }
}

export default connect(
    state => state.orderPlanner,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(OrderPlanner);


// WEBPACK FOOTER //
// ./src/components/sales/OrderPlanner.js